import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import { Button } from "@chakra-ui/react";
import { Title } from "../../Components/Atoms";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import { getSellerDevicesInStock } from "../../APIs";
import { useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";
import { getLocalisedNumber } from "../../Library/helpers";
import { StoreContext } from "../../Library/contexts";
import { DEV_TYPE_VALUES, DEVICE_TYPES } from "../../Library/constants";

let name = window.location.hostname.split(".")[0];
if (!name) name = "seller";

const Wallet = () => {
  const navigate = useNavigate();
  const { constants, devStock, setDevStock } = useContext(StoreContext);

  const handleButtonClick = () => {
    navigate(`${PATHS.DEALERS_OVERVIEW}/${PATHS.TRANSACTION_DETAILS}`);
  };

  useEffect(() => {
    if (!devStock || !devStock.count) {
      getSellerDevicesInStock((error, devStock) => {
        if (error) console.error(error);
        else {
          if (!devStock || !devStock.walletStock) return;

          let count = 0;
          DEVICE_TYPES.forEach(type => {
            if (devStock.walletStock[DEV_TYPE_VALUES[type.label]]) count += devStock.walletStock[DEV_TYPE_VALUES[type.label]] || 0;
          });

          setDevStock({ count: count, batWiseount: devStock.walletStock });
        }
      });
    }
  }, [])

  return (
    <div className="new-widget">
      <div className="new-widget-header">
        <Title variant="md" fixed>
          {constants.name} Stock
        </Title>
      </div>

      <div className="amnt-box-container">
        <div className="amnt-box">
          <span className="amnt-val">
            {(devStock && devStock.count) ? getLocalisedNumber(devStock.count) : "00"}
          </span>
          <span className="amnt-type">
            Devices in Stock
          </span>
        </div>
        {/* <div className="amnt-box">
          <span className="amnt-val">
          ₹{data?.spent ? getLocalisedNumber(data?.spent) : "00"}
          </span>
          <span className="amnt-type">
            <MoneyInHand />
            Spending
          </span>
        </div> */}
      </div>

      <div className="widget-link view-transactions-button">
        {/* <Button
          variant={"ghost"}
          onClick={handleButtonClick}
          rightIcon={<ArrowRightIcon />}
        >
          Transactions
        </Button> */}
      </div>
    </div>
  );
};

export default Wallet;
